import { useState } from "react"
import { URLS } from "../../_config"
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs"
import Layout from "../layout"
import Icon from "../../components/icons"
import { Link } from "react-router-dom"
import RightFilter from "./RightFilter"

const FundingRequestList = () => {
    const [showFilterRight, setShowFilterRight] = useState<any>(null);


    const handleCloseFilter = () => setShowFilterRight(null);
    return <Layout>
        <div className="container-fluid" data-aos="fade-up" data-aos-duration="1000">
            {/* <Breadcrumbs title="Funding Request" breadcrumbs={{ Home: URLS.PROFILE, 'Funding Request': "#" }} />  */}

            <div className="page-title-box d-flex align-items-center justify-content-between">


                <div className="d-flex align-items-center gap-15">
                    <h1 className="mb-0 text-xxl"> Loan  <span className="text-accent">Request</span></h1>
                    <div className="btn-group">
                        <button type="button" className="btn btn-primary dropdown-toggle rate_checker" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Rate Calculator <i className="mdi mdi-chevron-down"></i></button>
                        <div className="dropdown-menu">
                            <a className="dropdown-item" href="#">Polly Rate Checker</a>
                            <div className="dropdown-item multidropdown">Lender Price Rate Checker
                                <ul>
                                    <li>
                                        <a href="#">275 BPS</a>
                                    </li>
                                    <li>
                                        <a href="#">200 BPS</a>
                                    </li>
                                    <li>
                                        <a href="#">0 BPS</a>
                                    </li>
                                    <li>
                                        <a href="#">Account</a>
                                    </li>
                                    <li>
                                        <a href="#">Powered by <strong>Lender Price</strong></a>
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </div>
                </div>

                <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                        <li className="breadcrumb-item active">Loan Request</li>
                    </ol>
                </div>

            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">

                            <div className="d-flex justify-content-between mb-3 flex-col-sm">
                                <h2 className="font-size-16">Funding Request</h2>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-secondary d-flex gap-2 align-items-center right-bar-toggle" onClick={() => setShowFilterRight(true)}><i className="bx bx-filter-alt"></i> Filter</button>
                                    <Link to={URLS.FUNDING.SUBMIT_REQUEST} className="btn btn-light-secondary d-flex gap-2 align-items-center right-add-bar-toggle" ><Icon name="plus" /> Add Funding Request</Link>
                                </div>

                            </div>
                            <div className="table-responsive">
                                <table id="datatable" className="table table-bordered table-striped dt-responsive nowrap" style={{ borderCollapse: 'collapse', borderSpacing: '0', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Type</th>
                                            <th>Credit Score</th>
                                            <th>Location</th>
                                            <th>Amount</th>
                                            <th>Participant</th>
                                            <th>Add at</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>#245</td>
                                            <td>Refinance</td>
                                            <td>812</td>
                                            <td>202 Oak Street, Seattle, WA 98101</td>
                                            <td>$6125</td>
                                            <td>Caterina Byrd</td>
                                            <td>01-02-2025</td>
                                            <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                        </tr>
                                        <tr>
                                            <td>#545</td>
                                            <td>Purchase</td>
                                            <td>812</td>
                                            <td>456 Elm Avenue, Orlando, FL 32801</td>
                                            <td>$8125</td>
                                            <td>Karen Berryman</td>
                                            <td>12-02-2024</td>
                                            <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                        </tr>
                                        <tr>
                                            <td>#425</td>
                                            <td>Purchase</td>
                                            <td>802</td>
                                            <td>789 Pine Drive, Dallas, TX 75201</td>
                                            <td>$2825</td>
                                            <td>Megan Thompson</td>
                                            <td>12-10-2024</td>
                                            <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                        </tr>
                                        <tr>
                                            <td>#935</td>
                                            <td>Purchase</td>
                                            <td>832</td>
                                            <td>101 Maple Lane, Denver, CO 80201</td>
                                            <td>$9825</td>
                                            <td>Hatice Umur</td>
                                            <td>11-22-2024</td>
                                            <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                        </tr>
                                        <tr>
                                            <td>#935</td>
                                            <td>Construction</td>
                                            <td>832</td>
                                            <td>101 Maple Lane, Denver, CO 80201</td>
                                            <td>$1225</td>
                                            <td>Hatice Umur</td>
                                            <td>11-22-2024</td>
                                            <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                        </tr>

                                    </tbody>


                                </table>
                            </div>




                        </div>
                    </div>
                </div>
            </div>

        </div>
        <RightFilter show={showFilterRight} handleClose={handleCloseFilter} />

    </Layout>
}
export default FundingRequestList